import styles from '@components/components/CmsComponents/components/CmsContactForm/CmsContactForm.module.scss';
import React from 'react';
import {
  Checkbox,
  Content,
  FileUpload,
  InputField,
  Radio,
  Textarea,
} from '@wienenergiegithub/ui-next';
import {
  FormGroupLabel,
  FormRadioGroup,
  FormRadio,
  FormCheckbox,
  FormError,
  FormGroup,
} from '@ariakit/react';

function getFieldComponent(field, store, contact, t) {
  const label = `${field.label}${field.required ? '' : ' (optional)'}`;

  switch (field.type) {
    case 'email':
    case 'text':
      return (
        <InputField
          label={label}
          name={field.name}
          store={store}
          type={field.type}
        />
      );
    case 'textarea':
      return (
        <Textarea
          label={label}
          name={field.name}
          store={store}
          type={field.type}
        />
      );
    case 'checkbox':
      return (
        <>
          <FormCheckbox
            name={field.name}
            render={<Checkbox label={label} withParser />}
            store={store}
            type={field.type}
          />
          <FormError
            aria-atomic="true"
            className={styles.message}
            name={field.name}
            store={store}
          />
        </>
      );
    case 'optionGroup': {
      const [optionGroupLabel, ...values] = field.label.split('\n');
      return (
        <FormRadioGroup
          className={styles.radioGroup}
          name={field.name}
          store={store}
        >
          <FormGroupLabel
            className={styles.radioGroupLabel}
            name={field.name}
            render={
              <Content noSpacing size="sm" withParser>
                {`${optionGroupLabel}${field.required ? '' : ' (optional)'}`}
              </Content>
            }
            store={store}
          />
          {values.map(value => (
            <div className={styles.radioWrapper} key={value}>
              <FormRadio
                name={field.name}
                render={<Radio label={value} variant="horizontal" />}
                store={store}
                value={value}
              />
            </div>
          ))}

          <FormError
            aria-atomic="true"
            className={styles.message}
            name={field.name}
            store={store}
          />
        </FormRadioGroup>
      );
    }
    case 'checkboxGroup': {
      const [checkboxGroupLabel, ...values] = field.label.split('\n');

      return (
        <FormGroup name={field.name} store={store}>
          <FormGroupLabel
            className={styles.label}
            name={field.name}
            render={
              <Content noSpacing size="sm" withParser>
                {`${checkboxGroupLabel}${field.required ? '' : ' (optional)'}`}
              </Content>
            }
            store={store}
          />
          <div className={styles.checkboxItems}>
            {values.map(value => (
              <FormCheckbox
                className={styles.checkboxItem}
                key={value}
                name={field.name}
                render={<Checkbox align="center" label={value} withParser />}
                store={store}
                value={value}
              />
            ))}
          </div>
          <FormError
            aria-atomic="true"
            className={styles.message}
            name={field.name}
            store={store}
          />
        </FormGroup>
      );
    }
    case 'salutation':
      return (
        <FormRadioGroup name={field.name} store={store}>
          <FormGroupLabel
            className={styles.label}
            name={field.name}
            store={store}
          >
            {t('salutation')}
          </FormGroupLabel>
          <div className={styles.salutationRadios}>
            <FormRadio
              name={field.name}
              render={<Radio label={t('female')} />}
              required
              store={store}
              value={t('female')}
            />
            <FormRadio
              name={field.name}
              render={<Radio label={t('male')} />}
              required
              store={store}
              value={t('male')}
            />
          </div>
          <FormError
            aria-atomic="true"
            className={styles.message}
            name={field.name}
            store={store}
          />
        </FormRadioGroup>
      );
    case 'customText':
      return (
        <Content className={styles.customText} withParser>
          {field.label}
        </Content>
      );
    case 'upload':
      return (
        contact.upload && (
          <FileUpload
            accept={contact.upload.accept}
            description={contact.upload.description}
            heading={contact.upload.heading}
            label={field.label}
            maxFileCount={contact.upload.maxFiles.value}
            maxFileCountError={contact.upload.maxFiles.error}
            maxFileCountOverflowError={
              contact.upload.maxFiles.filesOverflowLimitError
            }
            maxUploadSize={contact.upload.maxUploadSize.value}
            maxUploadSizeError={contact.upload.maxUploadSize.error}
            multiple={contact.upload.multiple}
            name={field.name}
            onFileChange={files => store.setValue(field.name, files)}
            store={store}
          />
        )
      );
    default:
      return null;
  }
}

export default getFieldComponent;
